(function($) {

	$(document).on("gform_confirmation_loaded", function (e, form_id) {
		$('.footer__contact__bar').text('I\'m on it!');
	  	$('.footer__contact__form').css('height',192);
	});

})( jQuery );  